<svg viewBox="0 0 51 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<g clip-path="url(#clip0_3351_10383)">
		<mask
			id="mask0_3351_10383"
			style="mask-type:luminance"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="51"
			height="21"
		>
			<path d="M50.1228 0.5H0V20.5H50.1228V0.5Z" fill="white" />
		</mask>
		<g mask="url(#mask0_3351_10383)">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M3.28654 18.7774C2.66666 18.7774 2.35087 18.4721 2.35087 17.9704C2.35087 17.0347 3.39414 16.7201 5.29707 16.5177C5.29707 17.7645 4.45379 18.7774 3.28069 18.7774H3.28654ZM4.10525 11.7657C2.74502 11.7657 1.18128 12.4055 0.332153 13.0826L1.10759 14.7201C1.7883 14.0967 2.88888 13.5633 3.88186 13.5633C4.82572 13.5633 5.34736 13.8791 5.34736 14.5154C5.34736 14.9423 5.00233 15.1587 4.3497 15.2441C1.90993 15.5598 -0.00234985 16.2335 -0.00234985 18.1131C-0.00234985 19.6031 1.05847 20.5049 2.71578 20.5049C3.89941 20.5049 4.95204 19.8476 5.45262 18.9844V20.271H7.65847V14.8803C7.65847 12.6581 6.11578 11.761 4.10642 11.761L4.10525 11.7657Z"
				fill="black"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M26.2444 12.0077V20.2603H28.6047V16.2837C28.6047 14.3948 29.7485 13.8392 30.545 13.8392C30.9036 13.8364 31.2548 13.9403 31.5544 14.1375L31.986 11.9562C31.6514 11.8223 31.2934 11.7575 30.9333 11.7656C29.7205 11.7656 28.9579 12.3024 28.455 13.3948V12.0077H26.2444Z"
				fill="black"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M42.924 11.7656C41.676 11.7656 40.7427 12.5025 40.2573 13.2136C39.807 12.2955 38.8538 11.7656 37.7076 11.7656C36.4608 11.7656 35.5965 12.458 35.1977 13.2557V12.0077H32.9216V20.2604H35.2842V16.0113C35.2842 14.4908 36.083 13.7551 36.8281 13.7551C37.5029 13.7551 38.1228 14.1914 38.1228 15.3177V20.2604H40.4807V16.0113C40.4807 14.4686 41.2596 13.7551 42.0398 13.7551C42.6643 13.7551 43.3263 14.2089 43.3263 15.3013V20.2604H45.6842V14.5551C45.6842 12.7013 44.4362 11.7656 42.9286 11.7656"
				fill="black"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M20.5006 12.0077H18.3626V11.1691C18.3626 10.0767 18.986 9.76561 19.5228 9.76561C19.8894 9.77039 20.2497 9.86049 20.5754 10.0288L21.3029 8.36444C21.3029 8.36444 20.5649 7.88257 19.2234 7.88257C17.7158 7.88257 16 8.73286 16 11.4007V12.0077H12.4269V11.1691C12.4269 10.0767 13.0491 9.76561 13.5871 9.76561C13.9543 9.76559 14.3158 9.85596 14.6398 10.0288L15.3672 8.36444C14.9333 8.11064 14.2351 7.88257 13.2889 7.88257C11.7813 7.88257 10.0655 8.73286 10.0655 11.4007V12.0077H8.6994V13.8276H10.069V20.2603H12.4269V13.8276H16.0047V20.2603H18.3626V13.8276H20.5006V12.0077Z"
				fill="black"
			/>
			<path d="M24.2643 12.0076H21.9088V20.2567H24.2643V12.0076Z" fill="black" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M21.9953 10.6054H24.3029C25.6491 6.37261 30.2164 2.65215 35.6479 2.65215C42.2538 2.65215 47.9626 7.68139 47.9626 15.5106C47.9827 17.1176 47.7619 18.7187 47.3076 20.2603H49.5474L49.5696 20.1831C49.947 18.6569 50.1332 17.0898 50.124 15.5176C50.124 6.78665 43.7614 0.502441 35.6526 0.502441C29.283 0.502441 23.6058 4.92349 21.9965 10.6077L21.9953 10.6054Z"
				fill="#4A4AF4"
			/>
		</g>
	</g>
	<defs>
		<clipPath id="clip0_3351_10383">
			<rect width="50.1228" height="25" fill="white" transform="translate(0 0.5)" />
		</clipPath>
	</defs>
</svg>
